export default __webpack_public_path__ + "static/media/fb-white.c922bcfa.svg";